import { render, staticRenderFns } from "./ModalNotificationTransaction.vue?vue&type=template&id=46686280&"
import script from "./ModalNotificationTransaction.vue?vue&type=script&lang=js&"
export * from "./ModalNotificationTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotificationTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports